import { useMemo } from "react";

import { SyncListItemFragment } from "@/apollo/types";

import { useFilteredNotifications } from "./filterNotifications";

/**
 * Returns a flat list of all the notifications that may affect the RevEltSync
 *
 * This includes:
 * - Account notifications
 * - Connector notifications
 * - Sync notifications
 */
export const useReverseEltSyncNotifications = (
  syncOrSyncs: SyncListItemFragment[] | SyncListItemFragment,
) => {
  const syncs = Array.isArray(syncOrSyncs) ? syncOrSyncs : [syncOrSyncs];
  const stableDep = syncs.map((s) => s.id).join(",");

  const filters = useMemo(() => {
    const syncs = Array.isArray(syncOrSyncs) ? syncOrSyncs : [syncOrSyncs];
    return {
      connectionIds: syncs.map((sync) => sync.sourceConnectionId),
      syncIds: syncs.map((sync) => sync.id),
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stableDep]);

  return useFilteredNotifications(filters);
};
